/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRelationBase,
  PersonRelationBaseOptional,
  PersonRelationBaseMetaI,
  PersonRelationBaseTrackedI,
} from "./person-relation-base";
import {
  PersonRelationBaseTracked,
  PersonRelationBaseMeta,
} from "./person-relation-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRelationType,
  PersonRelationTypeOptional,
  PersonRelationTypeMetaI,
  PersonRelationTypeTrackedI,
} from "./person-relation-type";
import {
  PersonRelationTypeTracked,
  PersonRelationTypeMeta,
} from "./person-relation-type";

/**
 *
 * @export
 * @interface PersonRelationBaseDTO
 */
export interface PersonRelationBaseDTOOptional extends PersonRelationBaseOptional {
  /**
   *
   * @type {number}
   * @memberof PersonRelationBaseDTO
   */
  relationId?: number;
  /**
   *
   * @type {boolean}
   * @memberof PersonRelationBaseDTO
   */
  isPrimary?: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonRelationBaseDTO
   */
  aTitleOverride?: string;
  /**
   *
   * @type {string}
   * @memberof PersonRelationBaseDTO
   */
  bTitleOverride?: string;
  /**
   *
   * @type {PersonRelationType}
   * @memberof PersonRelationBaseDTO
   */
  relationTypeId?: PersonRelationType;
  /**
   *
   * @type {string}
   * @memberof PersonRelationBaseDTO
   */
  aTitle?: string;
  /**
   *
   * @type {string}
   * @memberof PersonRelationBaseDTO
   */
  bTitle?: string;
}

export interface PersonRelationBaseDTO
  extends PersonRelationBaseDTOOptional, PersonRelationBase {
  /**
   *
   * @type {number}
   * @memberof PersonRelationBaseDTO
   */
  relationId: number;
  /**
   *
   * @type {boolean}
   * @memberof PersonRelationBaseDTO
   */
  isPrimary?: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonRelationBaseDTO
   */
  aTitleOverride?: string;
  /**
   *
   * @type {string}
   * @memberof PersonRelationBaseDTO
   */
  bTitleOverride?: string;
  /**
   *
   * @type {PersonRelationType}
   * @memberof PersonRelationBaseDTO
   */
  relationTypeId?: PersonRelationType;
  /**
   *
   * @type {string}
   * @memberof PersonRelationBaseDTO
   */
  aTitle?: string;
  /**
   *
   * @type {string}
   * @memberof PersonRelationBaseDTO
   */
  bTitle?: string;
}

export interface PersonRelationBaseDTOTrackedI extends PersonRelationBaseOptional {
  /**
   *
   * @type {number}
   * @memberof PersonRelationBaseDTO
   */
  relationId?: number;
  relationIdIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonRelationBaseDTO
   */
  isPrimary?: boolean;
  isPrimaryIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonRelationBaseDTO
   */
  aTitleOverride?: string;
  aTitleOverrideIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonRelationBaseDTO
   */
  bTitleOverride?: string;
  bTitleOverrideIsSet: boolean;
  /**
   *
   * @type {PersonRelationType}
   * @memberof PersonRelationBaseDTO
   */
  relationTypeId?: PersonRelationType;
  relationTypeIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonRelationBaseDTO
   */
  aTitle?: string;
  aTitleIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonRelationBaseDTO
   */
  bTitle?: string;
  bTitleIsSet: boolean;
}

transformDatesMap.set(
  "PersonRelationBaseDTO",
  function (model: PersonRelationBaseDTO) {},
);

export type PersonRelationBaseDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  relationId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  isPrimary: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  aTitleOverride: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  bTitleOverride: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  relationTypeId: PropertyMeta<PersonRelationTypeMetaI>;
  //isDate: false
  //isDatetime: false
  aTitle: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  bTitle: PropertyMeta<MetaTypeBase<string>>;
}>;

export var PersonRelationBaseDTOMeta: PersonRelationBaseDTOMetaI =
  {} as PersonRelationBaseDTOMetaI;
PersonRelationBaseDTOMeta = typeMeta("PersonRelationBaseDTO", {
  relationId: propertyMeta(
    "relationId",
    false,
    true,
    true,
    MetaTypesBase.number,
  ),
  isPrimary: propertyMeta(
    "isPrimary",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  aTitleOverride: propertyMeta(
    "aTitleOverride",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  bTitleOverride: propertyMeta(
    "bTitleOverride",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  relationTypeId: propertyMeta(
    "relationTypeId",
    false,
    false,
    false,
    PersonRelationTypeMeta,
  ),
  aTitle: propertyMeta("aTitle", false, false, false, MetaTypesBase.string),
  bTitle: propertyMeta("bTitle", false, false, false, MetaTypesBase.string),
});

const metaI = PersonRelationBaseDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([PersonRelationBaseMeta]);
  metaI.relationId.inheritedFrom = PersonRelationBaseMeta.relationId;
  metaI.isPrimary.inheritedFrom = PersonRelationBaseMeta.isPrimary;
  metaI.aTitleOverride.inheritedFrom = PersonRelationBaseMeta.aTitleOverride;
  metaI.bTitleOverride.inheritedFrom = PersonRelationBaseMeta.bTitleOverride;
  metaI.relationTypeId.inheritedFrom = PersonRelationBaseMeta.relationTypeId;
});

export class PersonRelationBaseDTOTracked
  extends PersonRelationBaseTracked
  implements PersonRelationBaseDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  relationId__I?: number = undefined;

  get relationIdIsSet() {
    return this.relationId !== undefined;
  }
  set relationIdIsSet(v: boolean) {}
  set relationId(v: undefined | number) {
    if (v !== undefined) {
      this.relationId__I = v;
      this.relationIdIsSet = true;
    } else {
      this.relationId__I = v || undefined;
      this.relationIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get relationId() {
    return this.relationId__I;
  }
  isPrimary__I?: boolean = undefined;
  isPrimaryIsSet: boolean = false;
  set isPrimary(v: undefined | boolean) {
    if (v !== undefined) {
      this.isPrimary__I = v;
      this.isPrimaryIsSet = true;
    } else {
      this.isPrimary__I = v || undefined;
      this.isPrimaryIsSet = false;
    }
    this.changeTracker = true;
  }
  get isPrimary() {
    return this.isPrimary__I;
  }
  aTitleOverride__I?: string = undefined;
  aTitleOverrideIsSet: boolean = false;
  set aTitleOverride(v: undefined | string) {
    if (v !== undefined) {
      this.aTitleOverride__I = v;
      this.aTitleOverrideIsSet = true;
    } else {
      this.aTitleOverride__I = v || undefined;
      this.aTitleOverrideIsSet = false;
    }
    this.changeTracker = true;
  }
  get aTitleOverride() {
    return this.aTitleOverride__I;
  }
  bTitleOverride__I?: string = undefined;
  bTitleOverrideIsSet: boolean = false;
  set bTitleOverride(v: undefined | string) {
    if (v !== undefined) {
      this.bTitleOverride__I = v;
      this.bTitleOverrideIsSet = true;
    } else {
      this.bTitleOverride__I = v || undefined;
      this.bTitleOverrideIsSet = false;
    }
    this.changeTracker = true;
  }
  get bTitleOverride() {
    return this.bTitleOverride__I;
  }
  relationTypeId__I?: PersonRelationType = undefined;
  relationTypeIdIsSet: boolean = false;
  set relationTypeId(v: undefined | PersonRelationType) {
    if (v !== undefined) {
      this.relationTypeId__I = v;
      this.relationTypeIdIsSet = true;
    } else {
      this.relationTypeId__I = v || undefined;
      this.relationTypeIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get relationTypeId() {
    return this.relationTypeId__I;
  }
  aTitle__I?: string = undefined;
  aTitleIsSet: boolean = false;
  set aTitle(v: undefined | string) {
    if (v !== undefined) {
      this.aTitle__I = v;
      this.aTitleIsSet = true;
    } else {
      this.aTitle__I = v || undefined;
      this.aTitleIsSet = false;
    }
    this.changeTracker = true;
  }
  get aTitle() {
    return this.aTitle__I;
  }
  bTitle__I?: string = undefined;
  bTitleIsSet: boolean = false;
  set bTitle(v: undefined | string) {
    if (v !== undefined) {
      this.bTitle__I = v;
      this.bTitleIsSet = true;
    } else {
      this.bTitle__I = v || undefined;
      this.bTitleIsSet = false;
    }
    this.changeTracker = true;
  }
  get bTitle() {
    return this.bTitle__I;
  }
  constructor(config?: PersonRelationBaseDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.relationIdIsSet == true && other?.relationIdIsSet == true)
      return this.relationId == other.relationId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.relationId) {
      this.relationIdIsSet = true;
    }
  }
  assignFrom(
    config: PersonRelationBaseDTOOptional,
    options?: AssignOptions,
  ): PersonRelationBaseDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.relationId &&
      this.relationIdApplyFilter(optionsRequired.filter)
    ) {
      this.relationId = config.relationId;
      if (optionsRequired.unassign) this.relationIdIsSet = false;
      else this.relationIdIsSet = true;
    }
    if (config.isPrimary && this.isPrimaryApplyFilter(optionsRequired.filter)) {
      this.isPrimary = config.isPrimary;
      if (optionsRequired.unassign) this.isPrimaryIsSet = false;
      else this.isPrimaryIsSet = true;
    }
    if (
      config.aTitleOverride &&
      this.aTitleOverrideApplyFilter(optionsRequired.filter)
    ) {
      this.aTitleOverride = config.aTitleOverride;
      if (optionsRequired.unassign) this.aTitleOverrideIsSet = false;
      else this.aTitleOverrideIsSet = true;
    }
    if (
      config.bTitleOverride &&
      this.bTitleOverrideApplyFilter(optionsRequired.filter)
    ) {
      this.bTitleOverride = config.bTitleOverride;
      if (optionsRequired.unassign) this.bTitleOverrideIsSet = false;
      else this.bTitleOverrideIsSet = true;
    }
    if (
      config.relationTypeId &&
      this.relationTypeIdApplyFilter(optionsRequired.filter)
    ) {
      this.relationTypeId = config.relationTypeId;
      if (optionsRequired.unassign) this.relationTypeIdIsSet = false;
      else this.relationTypeIdIsSet = true;
    }
    if (config.aTitle && this.aTitleApplyFilter(optionsRequired.filter)) {
      this.aTitle = config.aTitle;
      if (optionsRequired.unassign) this.aTitleIsSet = false;
      else this.aTitleIsSet = true;
    }
    if (config.bTitle && this.bTitleApplyFilter(optionsRequired.filter)) {
      this.bTitle = config.bTitle;
      if (optionsRequired.unassign) this.bTitleIsSet = false;
      else this.bTitleIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonRelationBaseDTOTrackedI {
    const cloned = {} as PersonRelationBaseDTOTrackedI;
    if (
      this.relationIdIsSetDeep() &&
      this.relationIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.relationIdIsSet = true;
      cloned.relationId = this.relationId;
    } else {
      //cloned.relationIdIsSet = false
    }
    if (
      this.isPrimaryIsSetDeep() &&
      this.isPrimaryApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isPrimaryIsSet = true;
      cloned.isPrimary = this.isPrimary;
    } else {
      //cloned.isPrimaryIsSet = false
    }
    if (
      this.aTitleOverrideIsSetDeep() &&
      this.aTitleOverrideApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.aTitleOverrideIsSet = true;
      cloned.aTitleOverride = this.aTitleOverride;
    } else {
      //cloned.aTitleOverrideIsSet = false
    }
    if (
      this.bTitleOverrideIsSetDeep() &&
      this.bTitleOverrideApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.bTitleOverrideIsSet = true;
      cloned.bTitleOverride = this.bTitleOverride;
    } else {
      //cloned.bTitleOverrideIsSet = false
    }
    if (
      this.relationTypeIdIsSetDeep() &&
      this.relationTypeIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.relationTypeIdIsSet = true;
      cloned.relationTypeId = this.relationTypeId;
    } else {
      //cloned.relationTypeIdIsSet = false
    }
    if (
      this.aTitleIsSetDeep() &&
      this.aTitleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.aTitleIsSet = true;
      cloned.aTitle = this.aTitle;
    } else {
      //cloned.aTitleIsSet = false
    }
    if (
      this.bTitleIsSetDeep() &&
      this.bTitleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.bTitleIsSet = true;
      cloned.bTitle = this.bTitle;
    } else {
      //cloned.bTitleIsSet = false
    }
    if (!isDeleted(this) && !this.relationIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonRelationBaseDTOTrackedI {
    if (!this.relationIdApplyFilter(filter)) this.relationIdIsSet = false;

    if (!this.isPrimaryApplyFilter(filter)) this.isPrimaryIsSet = false;

    if (!this.aTitleOverrideApplyFilter(filter))
      this.aTitleOverrideIsSet = false;

    if (!this.bTitleOverrideApplyFilter(filter))
      this.bTitleOverrideIsSet = false;

    if (!this.relationTypeIdApplyFilter(filter))
      this.relationTypeIdIsSet = false;

    if (!this.aTitleApplyFilter(filter)) this.aTitleIsSet = false;

    if (!this.bTitleApplyFilter(filter)) this.bTitleIsSet = false;

    return this;
  }
  relationIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonRelationBaseDTOMeta.relationId,
      PersonRelationBaseDTOMeta,
      this.relationId,
      this,
    );
  }
  relationIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.relationIdIsSet && this.relationIdApplyFilter(filter)) return true;

    return false;
  }
  isPrimaryApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonRelationBaseDTOMeta.isPrimary,
      PersonRelationBaseDTOMeta,
      this.isPrimary,
      this,
    );
  }
  isPrimaryIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isPrimaryIsSet && this.isPrimaryApplyFilter(filter)) return true;

    return false;
  }
  aTitleOverrideApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonRelationBaseDTOMeta.aTitleOverride,
      PersonRelationBaseDTOMeta,
      this.aTitleOverride,
      this,
    );
  }
  aTitleOverrideIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.aTitleOverrideIsSet && this.aTitleOverrideApplyFilter(filter))
      return true;

    return false;
  }
  bTitleOverrideApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonRelationBaseDTOMeta.bTitleOverride,
      PersonRelationBaseDTOMeta,
      this.bTitleOverride,
      this,
    );
  }
  bTitleOverrideIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.bTitleOverrideIsSet && this.bTitleOverrideApplyFilter(filter))
      return true;

    return false;
  }
  relationTypeIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonRelationBaseDTOMeta.relationTypeId,
      PersonRelationBaseDTOMeta,
      this.relationTypeId,
      this,
    );
  }
  relationTypeIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.relationTypeIdIsSet && this.relationTypeIdApplyFilter(filter))
      return true;

    return false;
  }
  aTitleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonRelationBaseDTOMeta.aTitle,
      PersonRelationBaseDTOMeta,
      this.aTitle,
      this,
    );
  }
  aTitleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.aTitleIsSet && this.aTitleApplyFilter(filter)) return true;

    return false;
  }
  bTitleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonRelationBaseDTOMeta.bTitle,
      PersonRelationBaseDTOMeta,
      this.bTitle,
      this,
    );
  }
  bTitleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.bTitleIsSet && this.bTitleApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.relationIdIsSetDeep(filter)) return true;
    if (this.isPrimaryIsSetDeep(filter)) return true;
    if (this.aTitleOverrideIsSetDeep(filter)) return true;
    if (this.bTitleOverrideIsSetDeep(filter)) return true;
    if (this.relationTypeIdIsSetDeep(filter)) return true;
    if (this.aTitleIsSetDeep(filter)) return true;
    if (this.bTitleIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
